
import {
  defineComponent, onBeforeUnmount, onMounted, PropType, ref,
} from 'vue'
import axios from 'axios'
import Webinar from '@/vue/public/Webinar.vue'
import Loading from '@/vue/public/Loading.vue'
import { Webinar as WebinarData, WebinarSchedule } from '@/types/webinar.d'
import { doQueue, request, setOption } from '@/scripts/combinedRequest'
import periodic, { CancelFunc } from '@/scripts/periodic'

export default defineComponent({
  name: 'WebinarPage',
  components: {
    Loading,
    Webinar,
  },
  props: {
    webinar: Object as PropType<WebinarData | null>,
    archived: Boolean,
  },
  setup(props) {
    const loading = ref(true)
    const error = ref(false)

    const schedule = ref<WebinarSchedule>({
      id: 0,
      startAt: 0,
      endAt: 0,
      finished: false,
      left: 0,
    })

    const reallyArchived = ref(false)

    const checkArchived = async () => {
      const { data } = await axios.get(`/webinars/${props.webinar?.id}/is-archived`)
      reallyArchived.value = !!data.archived
    }

    const cancels: CancelFunc[] = []
    onBeforeUnmount(() => cancels.forEach((c) => c()))

    onMounted(async () => {
      loading.value = true
      if (props.webinar) {
        setOption('webinar', props.webinar.id)
        if (props.archived) {
          await checkArchived()
        } else {
          cancels.push(periodic(10000, () => {
            if (props.webinar) {
              const scheduleId = +(localStorage.getItem(`webinar-${props.webinar.id}`) || 0)
              setOption('schedule', scheduleId)
            }
            return request<WebinarSchedule | null>('schedule').then((data) => {
              if (data) {
                schedule.value = data
                setOption('schedule', data.id)
                if (props.webinar) {
                  localStorage.setItem(`webinar-${props.webinar.id}`, `${data.id}`)
                }
              } else if (props.webinar?.archived) {
                schedule.value = {
                  id: 0,
                  startAt: 0,
                  endAt: 0,
                  finished: true,
                  left: 0,
                }
                checkArchived()
              } else {
                error.value = true
              }
            })
          }))
        }
        cancels.push(periodic(3000, doQueue))
      } else {
        error.value = true
      }
      loading.value = false
    })

    return {
      loading,
      error,
      schedule,
      reallyArchived,
    }
  },
})
